export const resolveTargets = (tars: string[]) =>
  tars.length > 1 ? `${tars.length} users` : tars[0];
